import React from "react";
import EAPieChart from "../../../components/common/charts/EAPieChart";
import EAIcon from "../../../components/common/EAIcon";
import useStyles from "../../../style/js-style/containers/dashboard/DashboardStyle";
import i18n from '../../../i18n/i18n';


function RiskScorePieChart({ subTab, scoreLabel="", scoreCount, legendHeightPercent, legendTitle, disableClick = false }) {
  const { classes } = useStyles();

  return (
    <>
      <div
        className={classes.pieContainer}
        style={{ display: scoreCount?.total === "0" ? "flex" : "none" }}
      >
        <EAIcon icon="search_off" />
        <div className={classes.pieNoDataText}>
          <span className={classes.bolder}>{i18n.t("dashboard.risks.noThirdparty")}</span> {i18n.t("dashboard.risks.associatedWithYourSearch")}
        </div>
      </div>

      {scoreCount?.total !== "0" && (
        <EAPieChart
          id={`${subTab}-${scoreLabel}-chart`}
          data={scoreCount}
          tab={"risks"}
          subTab={subTab}
          legendHeightPercent={legendHeightPercent}
          legendTitle={legendTitle}
          disableClick={disableClick}
        />
      )}
    </>
  );
}

export default RiskScorePieChart;
